import { useTranslateContext } from "fennec-ui";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router";
import { access } from "../../../../../common/Tool";
import MenuLevelThree from "../../../../components/MenuLevelThree";
import Calendar from "./Calendar";
import Festivali from "./Festivali";
import Serii from "./Serii";
import Myevents from "./Myevents";
import ByIDAvatar from "../../../EventAvatar/ByIDAvatar";
// import ByIDAvatar from "./ByIDAvatar";

const menu = (status, notify) => {
    const x = [
        {
            uuid: "my-events",
            default: true,
            name: "Мои мероприятия",
            component: (props) => (<Myevents {...props}/>),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ]
        },
        // {
        //     uuid: "calendar",
        //     name: "Мероприятия",
        //     component: (props) => (<Calendar {...props}/>),
        //     role: [
        //         { "ID": 4, "nazvanie": "ОбычныйПользователь" },
        //     ]
        // },
        // {
        //     uuid: "festivali",
        //     name: "Фестивали",
        //     component: (props) => (<Festivali {...props}/>),
        //     role: [
        //         { "ID": 4, "nazvanie": "ОбычныйПользователь" },
        //     ]
        // },
        // {
        //     uuid: "serii",
        //     name: "Серии",
        //     component: (props) => (<Serii {...props}/>),
        //     role: [
        //         { "ID": 4, "nazvanie": "ОбычныйПользователь" },
        //     ]
        // },
        {
            hidden: true,
            uuid: ":id/avatar",
            name: "Аватарка \"по-быстрому\"",
            component: (props) => (<ByIDAvatar {...props}/>),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ]
        }
    ]
    return x
};

export default function Events(props) {
    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status);
    const notify = useSelector(state => state.home.notify);
    const t = useTranslateContext();

    return (<div className='page' style={{ height: "100%", padding:"0px 5px" }}>
                <MenuLevelThree menu={menu(status, notify)} />
                <Routes>
                    {menu(status, notify).map((e, idx) => {
                        if (e.default && access(e, role_by_id)) {
                            return <Route key={"index-" + e.uuid} index element={<Navigate replace to={e.uuid} />} />
                        }
                    })}
                    {menu(status, notify).map((e, idx) => {
                        if (e.component && access(e, role_by_id)) {
                            return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={e.component({
												level: {
													parent: props?.level,
													uuid: e?.uuid,
													name: e?.name,
													color: e?.color,
													role: e?.role,
                                                    hidden: e.hidden
												},
											 })} />
                        }
                    })}
                </Routes>
    </div>)
}

